import { render, staticRenderFns } from "./JiraTimeUpdate.vue?vue&type=template&id=717f4594&scoped=true&"
import script from "./JiraTimeUpdate.vue?vue&type=script&lang=js&"
export * from "./JiraTimeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f4594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717f4594')) {
      api.createRecord('717f4594', component.options)
    } else {
      api.reload('717f4594', component.options)
    }
    module.hot.accept("./JiraTimeUpdate.vue?vue&type=template&id=717f4594&scoped=true&", function () {
      api.rerender('717f4594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SprintPlanning/Components/JiraTimeUpdate.vue"
export default component.exports